var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgListViewIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50033 16.6667C7.50033 16.3905 7.72418 16.1667 8.00033 16.1667L18.8337 16.1667C19.1098 16.1667 19.3337 16.3905 19.3337 16.6667C19.3337 16.9428 19.1098 17.1667 18.8337 17.1667L8.00033 17.1667C7.72418 17.1667 7.50033 16.9428 7.50033 16.6667Z",
    fill: "#23252F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50033 10C7.50033 9.72386 7.72418 9.5 8.00033 9.5L18.8337 9.5C19.1098 9.5 19.3337 9.72386 19.3337 10C19.3337 10.2761 19.1098 10.5 18.8337 10.5L8.00033 10.5C7.72418 10.5 7.50033 10.2761 7.50033 10Z",
    fill: "#23252F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50033 3.33333C7.50033 3.05719 7.72418 2.83333 8.00033 2.83333H18.8337C19.1098 2.83333 19.3337 3.05719 19.3337 3.33333C19.3337 3.60948 19.1098 3.83333 18.8337 3.83333H8.00033C7.72418 3.83333 7.50033 3.60948 7.50033 3.33333Z",
    fill: "#23252F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83374 3.33333C3.83374 3.79357 3.46064 4.16667 3.00041 4.16667C2.54017 4.16667 2.16707 3.79357 2.16707 3.33333C2.16707 2.8731 2.54017 2.5 3.00041 2.5C3.46064 2.5 3.83374 2.8731 3.83374 3.33333Z",
    fill: "#23252F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83366 10C3.83366 10.4602 3.46056 10.8333 3.00033 10.8333C2.54009 10.8333 2.16699 10.4602 2.16699 10C2.16699 9.53976 2.54009 9.16667 3.00033 9.16667C3.46056 9.16667 3.83366 9.53976 3.83366 10Z",
    fill: "#23252F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83366 16.6667C3.83366 17.1269 3.46056 17.5 3.00033 17.5C2.54009 17.5 2.16699 17.1269 2.16699 16.6667C2.16699 16.2064 2.54009 15.8333 3.00033 15.8333C3.46056 15.8333 3.83366 16.2064 3.83366 16.6667Z",
    fill: "#23252F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListViewIcon);
export default ForwardRef;